import ArrowExpandIcon from '@/components/icons/ArrowExpandIcon';
import DashboardCircleIcon from '@/components/icons/DashboardCircleIcon';
import DoorIcon from '@/components/icons/DoorIcon';
import LocationIcon from '@/components/icons/LocationIcon';
import { cn } from '@/lib/utils';
import { t } from 'i18next';
import { FC, ReactNode } from 'react';

const CardProps = {
	'Cadastral code': {
		icon: LocationIcon,
		text: 'main.apartments.components.card.elements.cadastralCode',
		unit: '',
	},
	Squareness: {
		icon: ArrowExpandIcon,
		text: 'main.apartments.components.card.elements.squareness',
		unit: 'm²',
	},
	Property: {
		icon: DoorIcon,
		text: 'main.apartments.components.card.elements.property',
		unit: '',
	},
	OtherServices: {
		icon: DashboardCircleIcon,
		text: 'main.apartments.components.card.elements.otherServices',
		unit: '',
	},
};

type Props = {
	property: keyof typeof CardProps;
	value: string | ReactNode;
	variant?: 'desktop' | 'mobile';
};

const ApartmentsCardField: FC<Props> = ({ property, value, variant }) => {
	const IconComponent = CardProps[property].icon;

	return (
		<div
			className={cn(
				'flex items-center gap-2.5 text-sm',
				variant === 'desktop' ? 'justify-between' : '',
			)}>
			<div className='flex items-center gap-2.5'>
				<IconComponent className='stroke-popover-1000' />
				{variant === 'desktop' && (
					<span>{t(CardProps[property].text)}</span>
				)}
			</div>
			<span>{value === 'string' ? value + ' ' + CardProps[property].unit : value}</span>
		</div>
	);
};

export default ApartmentsCardField;
